// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-play-my-clips-video-modal.modal2 {
    background-color: rgba(0, 0, 0, 0.9);
}

.baloa-play-my-clips-video-modal .modal2__container {
    width: 90%;
    height: 90%;
    box-shadow: none;
}

.baloa-play-my-clips-video-modal .modal2__header {
    background: transparent;
    color: var(--white-color);
    border-bottom: none;
}

.baloa-play-my-clips-video-modal .modal2__header__title.baloa-subtitle-2 {
    color: var(--white-color) !important;
    font-size: 30px;
    font-weight: 700;
}

.baloa-play-my-clips-video-modal .modal2__header__close_icon {
    color: var(--white-color);
    padding: 5px;
    background: var(--primary-dark-color);
    border-radius: 50%;
    font-size: 40px;
}

.baloa-play-my-clips-video-modal .modal2__content {
    background: transparent;
    padding-top: 60px;
}


.baloa-play-my-clips-video-modal__container{
    display: flex;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    justify-content: space-between;
}


.baloa-play-my-clips-video-modal__media-container {
    position: relative;
    width: 100%;
    height: auto;
}

.baloa-play-my-clips-video-modal__video-container {
    position: relative;
    width: 100%;
    height: 100vh;
    text-align: center;
}


@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 

    .baloa-play-my-clips-video-modal .modal2__container {
        width: 100%;
        margin: 0;
        height: 100%;
        max-height: unset;
    }

    .baloa-play-my-clips-video-modal .modal2__header {
        padding: 13px 15px;
    }

    .baloa-play-my-clips-video-modal .modal2__header__title.baloa-subtitle-2 {
        font-size: 16px;
        font-weight: var(--font-medium);
        padding: 0;
    }

    .baloa-play-my-clips-video-modal .modal2__header__close_icon {
        background: none;
        margin-left: auto;
        padding: 0;
        font-size: 24px;
    }

    .baloa-play-my-clips-video-modal .modal2__content {
        padding-top: 0;
    }

    .baloa-play-my-clips-video-modal__media-container {
        width: 100%;
        height: inherit;
    }

    .baloa-play-my-clips-video-modal__container {
        gap: 0;
        height: 90vh;
    }

    .baloa-play-my-clips-video-modal__video-container {
        width: 100%;
        margin: auto;
        height: 100%;
    }

}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/components/baloa-play-my-clips-video-modal-component/BaloaPlayMyClipsVideoModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,8BAA8B;AAClC;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;;AAGA,yCAAyC,4BAA4B;;IAEjE;QACI,WAAW;QACX,SAAS;QACT,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,+BAA+B;QAC/B,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,MAAM;QACN,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;AAEJ","sourcesContent":[".baloa-play-my-clips-video-modal.modal2 {\n    background-color: rgba(0, 0, 0, 0.9);\n}\n\n.baloa-play-my-clips-video-modal .modal2__container {\n    width: 90%;\n    height: 90%;\n    box-shadow: none;\n}\n\n.baloa-play-my-clips-video-modal .modal2__header {\n    background: transparent;\n    color: var(--white-color);\n    border-bottom: none;\n}\n\n.baloa-play-my-clips-video-modal .modal2__header__title.baloa-subtitle-2 {\n    color: var(--white-color) !important;\n    font-size: 30px;\n    font-weight: 700;\n}\n\n.baloa-play-my-clips-video-modal .modal2__header__close_icon {\n    color: var(--white-color);\n    padding: 5px;\n    background: var(--primary-dark-color);\n    border-radius: 50%;\n    font-size: 40px;\n}\n\n.baloa-play-my-clips-video-modal .modal2__content {\n    background: transparent;\n    padding-top: 60px;\n}\n\n\n.baloa-play-my-clips-video-modal__container{\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    width: 100%;\n    justify-content: space-between;\n}\n\n\n.baloa-play-my-clips-video-modal__media-container {\n    position: relative;\n    width: 100%;\n    height: auto;\n}\n\n.baloa-play-my-clips-video-modal__video-container {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    text-align: center;\n}\n\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n\n    .baloa-play-my-clips-video-modal .modal2__container {\n        width: 100%;\n        margin: 0;\n        height: 100%;\n        max-height: unset;\n    }\n\n    .baloa-play-my-clips-video-modal .modal2__header {\n        padding: 13px 15px;\n    }\n\n    .baloa-play-my-clips-video-modal .modal2__header__title.baloa-subtitle-2 {\n        font-size: 16px;\n        font-weight: var(--font-medium);\n        padding: 0;\n    }\n\n    .baloa-play-my-clips-video-modal .modal2__header__close_icon {\n        background: none;\n        margin-left: auto;\n        padding: 0;\n        font-size: 24px;\n    }\n\n    .baloa-play-my-clips-video-modal .modal2__content {\n        padding-top: 0;\n    }\n\n    .baloa-play-my-clips-video-modal__media-container {\n        width: 100%;\n        height: inherit;\n    }\n\n    .baloa-play-my-clips-video-modal__container {\n        gap: 0;\n        height: 90vh;\n    }\n\n    .baloa-play-my-clips-video-modal__video-container {\n        width: 100%;\n        margin: auto;\n        height: 100%;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
